import React, { useContext } from 'react';
import { NotFound, GlobalContext } from 'commons';

const NotFoundPage = () => {
  const { organization: { orgName } } = useContext(GlobalContext);

  return (
    <div className="container">
      <div className="well ssp-well">
        <NotFound orgName={orgName} />
      </div>
    </div>
  );
};

export default NotFoundPage;
